import { Box, Grid, makeStyles, Paper } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import { useObserver } from 'mobx-react-lite';
import React, { Fragment, FC } from 'react';
import OrderDetailDialog from '../OrderingPage/OrderDetail/OrderDetailDialog';
import { LayoutVariant } from '../Core/CommonTypes';
import EditOrderItem from '../OrderingPage/EditOrderItem/EditOrderItem';
import { isNullOrUndefined } from 'util';
import { ShopStore } from '../../stores/ShopStore';
import ShopOrderingInteraction from './ShopOrderingInteraction';
import ShopOrderDetailArea from './ShopOrderDetailArea';

const useStyles = makeStyles(theme => ({
  orderingContainer: {
    height: '100%',
    flexWrap: 'nowrap'
  },
  orderDetail: {
    minHeight: 480,
    padding: theme.spacing(1),
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.common.black : grey[50],
    minWidth: theme.spacing(42),
    flex: '1 1 auto'
  },
  orderingInteraction: {
    paddingTop: theme.spacing(1) / 2
  },
  orderingDetail: {
    flexWrap: 'nowrap',
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

interface ShopOrderProps {
  shopStore: ShopStore;
  showOrderDetailDialog: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
  variant?: LayoutVariant;
}

const ShopOrder: FC<ShopOrderProps> = ({
  shopStore,
  showOrderDetailDialog,
  onSubmit,
  onClose,
  variant
}: ShopOrderProps) => {
  const classes = useStyles();

  const menu = useObserver(() => (
    <ShopOrderingInteraction
      selectItem={item => shopStore.createItem(item)}
      items={shopStore.shopInfo.items}
      isItemAvailable={item => shopStore.isItemAvailable(item)}
      variant={variant}
    />
  ));

  const editOrderItemDialog = useObserver(
    () =>
      !isNullOrUndefined(shopStore.editingOrderItem) && (
        <EditOrderItem
          orderItem={shopStore.editingOrderItem}
          onClose={() => shopStore.finishEditing(false)}
          onSave={() => shopStore.finishEditing(true)}
          variant={variant}
        />
      )
  );

  const cartDialog = useObserver(() => (
    <OrderDetailDialog onClose={onClose} onSubmit={onSubmit} />
  ));

  return (
    <Fragment>
      {variant === LayoutVariant.mobile ? (
        menu
      ) : (
        <Grid container className={classes.orderingContainer}>
          <Grid key="ordering" item xs={8}>
            <Box className={classes.orderingInteraction}>{menu}</Box>
          </Grid>
          <Grid
            key="detail"
            item
            xs={4}
            container
            direction="column"
            className={classes.orderingDetail}
          >
            <Paper className={classes.orderDetail}>
              <ShopOrderDetailArea onSubmit={onSubmit} />
            </Paper>
          </Grid>
        </Grid>
      )}
      {shopStore.editingOrderItem && editOrderItemDialog}
      {showOrderDetailDialog && cartDialog}
    </Fragment>
  );
};

export default ShopOrder;
